export default (
  <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="8" fill="black" />

    {/* R letter */}
    <path
      d="M15 20H45C52 20 58 26 58 33C58 40 52 46 45 46H32V55L50 75H35L20 55V75H15V20ZM20 25V41H45C49 41 53 37 53 33C53 29 49 25 45 25H20Z"
      fill="white"
    />

    {/* Exclamation mark - vertical bar */}
    <rect x="65" y="20" width="15" height="40" fill="white" />

    {/* Exclamation mark - dot */}
    <rect x="65" y="65" width="15" height="12" fill="white" />
  </svg>
);
